// extracted by mini-css-extract-plugin
module.exports = {"strength-root":"VsRatingBar_strength-root__2vOmy","strength-title":"VsRatingBar_strength-title__1dplf","strength-img":"VsRatingBar_strength-img__1rDXi"};